<section class="availabilitiesForm">
	<!-- Loader. -->
	<section *ngIf="isLoading" style="text-align: center">
		<img
			src="/assets/images/preloaders/global_preloader.gif"
			style="margin-top: 20px"
		/>
	</section>

	<!-- Form. -->
	<section *ngIf="!isLoading">
		<!-- Add availabilities. -->
		<div class="formContainer fcSelect" style="height: 60px">
			<div class="divSelIcon" style="float: left">
				<img class="mnuIcon" src="/assets/images/icons/availabilities3.svg" />
			</div>
			<div class="divSelField">
				{{ 'GENERAL.AVAILABILITY' | translate }}
			</div>
			<div class="divSelAdd" (click)="add()">
				<img class="mnuIcon" src="/assets/images/icons/add2.svg" />
			</div>
		</div>
		<!-- /fcSelect. -->

		<!-- List container. -->
		<div
			*ngFor="let availability of avList; let i = index"
			class="formContainer avList"
		>
			<div class="avListSlots">
				<div>
					<div class="row">
						<div class="avLabel">
							{{ 'GENERAL.FROM' | translate | uppercase }}
						</div>
						<div class="avDate">
							{{ availability | infullDate: 'startDate' | uppercase }}
						</div>
					</div>
					<div class="row">
						<div class="avLabel">
							{{ 'GENERAL.TO' | translate | uppercase }}
						</div>
						<div class="avDate">
							{{ availability | infullDate: 'endDate' | uppercase }}
						</div>
					</div>
				</div>
				<div class="avTimeSlots">
					<table class="table">
						<tr *ngFor="let ts of availability.periods">
							<td>{{ daysOfWeek[ts.dayOfWeek] | uppercase }}</td>
							<td class="tdTime">
								{{ ts.startTime | shortTime }} - {{ ts.endTime | shortTime }}
							</td>
						</tr>
					</table>
				</div>
			</div>

			<div class="avListButtons">
				<img
					(click)="edit(availability)"
					class="mnuIcon btnEdit"
					src="/assets/images/icons/edit.svg"
				/>
				<img
					(click)="remove(availability.id)"
					class="mnuIcon btnEdit"
					src="/assets/images/icons/delete.svg"
				/>
			</div>
		</div>
	</section>
	<!-- /!isLoading. -->
</section>
<!-- /availabilitiesForm. -->
